export enum OperatorType {
  Equals = 0,
  NotEquals = 1,
  Greater = 2,
  Lower = 3,
  GreaterOrEqual = 4,
  LowerOrEqual = 5,
  IsNull = 6,
  IsNotNull = 7,
  In = 8,
  Between = 9,
  Contains = 10,
  StartsWith = 11,
  IsEmpty = 12,
  IsSameDay = 13,
  IsSameMinute = 14,
  IsSameYear = 15,
  IsSameMonth = 16,
  IsInLastMonth = 17,
  IsNullOrEmpty = 19,
  IsNotNullOrEmpty = 20,
  IsBuAncestor = 21,
  IsBuDescendant = 22,
  Accuracy = 23,
  AccuracyMin = 24,
  AccuracyMax = 25,
}

export type OperatorNames =
  | 'Equals'
  | 'NotEquals'
  | 'Greater'
  | 'Lower'
  | 'GreaterOrEqual'
  | 'LowerOrEqual'
  | 'IsNull'
  | 'IsNotNull'
  | 'In'
  | 'Between'
  | 'Contains'
  | 'StartsWith'
  | 'IsEmpty'
  | 'IsInLastMonth'
  | 'IsNullOrEmpty'
  | 'IsNotNullOrEmpty'
  | 'IsBuAncestor'
  | 'IsBuDescendant'
  | 'Is'
  | 'IsNot'
  | 'After'
  | 'OnOrAfter'
  | 'OnOrBefore'
  | 'Before'
